import {
  CREATE_USER_FAILURE,
  CREATE_USER_SUCCESS,
  CREATE_USER,
  GET_ALL_USER_FAILURE,
  GET_ALL_USER_SUCCESS,
  FETCH_ALL_USERS,
  FETCH_USER,
  GET_USER_SUCCESS,
  GET_USER_FAILURE,
  UPDATE_USER,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_FAILURE,
  CHECK_USER,
  CHECK_USER_FAILURE,
  CHECK_USER_SUCCESS,
} from "../constant";

import { Auth, API } from "aws-amplify";
import { X_API_KEY } from "../../Constants";

const getAllUserSuccess = (userData) => {
  return {
    type: GET_ALL_USER_SUCCESS,
    payload: {
      success: userData.success,
      users: userData.message.rows,
    },
  };
};

const getAllUserFailure = (error) => {
  return {
    type: GET_ALL_USER_FAILURE,
    payload: { error },
  };
};

const fetchAllUsers = () => {
  return {
    type: FETCH_ALL_USERS,
  };
};

export const getAllUsers = (offset, limit) => {
  return async (dispatch) => {
    dispatch(fetchAllUsers());
    API.get('AdminQueries', '/api/v1/getallusers', {
      queryStringParameters: {
        offset,
        limit,
      },

      headers: {
        Authorization: (await Auth.currentSession())
          .getAccessToken()
          .getJwtToken(),
      },
    })
      .then((res) => {
        dispatch(getAllUserSuccess(res));
      })
      .catch((err) => {
        dispatch(
          getAllUserFailure(
            err?.response?.data?.message
              ? err?.response?.data?.message
              : err.message
          )
        );
      });
  };
};

const getUserSuccess = (userData) => {
  return {
    type: GET_USER_SUCCESS,
    payload: {
      success: userData.success,
      user:
        userData?.message?.rows[0]?.rights.toLowerCase() === "superadmin"
          ? {
            ...userData?.message.rows[0],
            park_id: localStorage.getItem("parkID"),
          }
          : userData?.message.rows[0],
    },
  };
};

const getUserFailure = (error) => {
  return {
    type: GET_USER_FAILURE,
    payload: { error },
  };
};

export const fetchUser = () => {
  return {
    type: FETCH_USER,
  };
};

export const getUser = () => {
  return async (dispatch) => {
    dispatch(fetchUser());
    API.get('UserQueries', '/api/v1/getuser', {
      queryStringParameters: {
        user_id: localStorage.getItem("userID"),
      },
      headers: {
        Authorization: (await Auth.currentSession())
          .getAccessToken()
          .getJwtToken(),
      },
    })
      .then((res) => {
        dispatch(getUserSuccess(res));
      })
      .catch((err) => {
        dispatch(
          getUserFailure(
            err?.response?.data?.message
              ? err?.response?.data?.message
              : err.message
          )
        );
      });
  };
};

const createUserSuccess = (userData) => {
  return {
    type: CREATE_USER_SUCCESS,
    payload: {
      success: userData.success,
      message: userData.message,
    },
  };
};

const createUserFailure = (error) => {
  return {
    type: CREATE_USER_FAILURE,
    payload: { error },
  };
};

export const createuser = () => {
  return {
    type: CREATE_USER,
  };
};

export const createUser = (data) => {
  return async (dispatch) => {
    dispatch(createuser());
    API.post('AdminQueries', '/api/v1/createuser', {
      body: data,
      headers: {
        Authorization: (await Auth.currentSession())
          .getAccessToken()
          .getJwtToken(),
      },
    })
      .then((res) => {
        dispatch(createUserSuccess(res));
      })
      .catch((err) => {
        dispatch(
          createUserFailure(
            err?.response?.data?.message
              ? err?.response?.data?.message
              : err.message
          )
        );
      });
  };
};

const updateUserSuccess = (userData) => {
  return {
    type: UPDATE_USER_SUCCESS,
    payload: {
      success: userData.success,
      message: userData.message,
    },
  };
};

const updateUserFailure = (error) => {
  return {
    type: UPDATE_USER_FAILURE,
    payload: { error },
  };
};

export const updateuser = () => {
  return {
    type: UPDATE_USER,
  };
};

export const updateUser = (data) => {
  return async (dispatch) => {
    dispatch(updateuser());
    API.put('AdminQueries', '/api/v1/updateuser', {
      body: data,
      headers: {
        Authorization: (await Auth.currentSession())
          .getAccessToken()
          .getJwtToken(),
      },
    })
      .then((res) => {
        dispatch(updateUserSuccess(res));
      })
      .catch((err) => {
        dispatch(
          updateUserFailure(
            err?.response?.data?.message
              ? err?.response?.data?.message
              : err.message
          )
        );
      });
  };
};

const checkUserSuccess = (userData) => {
  return {
    type: CHECK_USER_SUCCESS,
    payload: {
      success: userData.success,
      checkUser: userData.message,
    },
  };
};

const checkUserFailure = (error) => {
  return {
    type: CHECK_USER_FAILURE,
    payload: { error },
  };
};

const checkuser = () => {
  return {
    type: CHECK_USER,
  };
};

export const checkUser = (data) => {
  return async (dispatch) => {
    dispatch(checkuser());
    API.get('AdminQueries', '/api/v1/checkuser', {
      queryStringParameters: {
        email: data.email,
        park_id: data.park_id,
      },
      headers: {
        "X-API-KEY": X_API_KEY,
      },
    })
      .then((res) => {
        dispatch(checkUserSuccess(res));
      })
      .catch((err) => {
        dispatch(
          checkUserFailure(
            err?.response?.data?.message
              ? err?.response?.data?.message
              : err.message
          )
        );
      });
  };
};
